var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.shouldShowIcpInfo)?_c('div',{staticClass:"icp-info",class:{ 
    'fixed-position': _vm.isFixed,
    'at-bottom': !_vm.isFixed 
  }},[_vm._m(0)]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icp-content"},[_c('span',{staticClass:"company-name"},[_vm._v("网信算备310104666296401240017号")]),_c('span',{staticClass:"company-info"},[_vm._v("Shanghai-JinShengYuLiang-202503260042")])])}]

export { render, staticRenderFns }